import React from 'react';

interface ResyncSnackbarMessageProps {
  resultsDelta: number;
}

const ResyncSnackbarMessage: React.FC<ResyncSnackbarMessageProps> = ({ resultsDelta }) => {
  const plural = Math.abs(resultsDelta) !== 1 ? 'results were' : 'result was';

  if (resultsDelta > 0) {
    return (
      <>
        <strong>
          {resultsDelta} {plural} added.
        </strong>
        &nbsp;Not what you were looking for?
      </>
    );
  } else if (resultsDelta < 0) {
    const abs = Math.abs(resultsDelta);
    return (
      <>
        <strong>
          {abs} {plural} removed.
        </strong>
        &nbsp;Not what you were looking for?
      </>
    );
  }

  return (
    <>
      <strong>Re-inspect completed.</strong>&nbsp;Not the results you were looking for?
    </>
  );
};

// Factory function that can be called from .ts files
export const createResyncMessage = (resultsDelta: number): React.ReactElement => {
  return React.createElement(ResyncSnackbarMessage, { resultsDelta });
};

export default ResyncSnackbarMessage;
